<script lang="ts">
  import Layout from "$app/Layouts/Plan.svelte"
  import { ChevronDown } from "lucide-svelte"
  import PlanRow from "./PlanRow.svelte"
  import Dropdown from "$app/components/Dropdown.svelte"

  let props = $props()
  let { plans, coaching_plans, current_user } = props

  let openDropdown = $state(false)
</script>

<Layout {...props}>
  <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
    <section class="max-w-3xl mx-auto lg:max-w-7xl">
      <div class="py-8 lg:py-12">
        <h2
          class="text-center text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
        >
          Your Plans
        </h2>
      </div>
    </section>

    <section class="max-w-3xl mx-auto lg:max-w-7xl px-3 lg:px-0">
      <div class="flex flex-col">
        {#if plans.length === 0}
          <div id="noplans" class="well">
            <h4>You have not created any plans to manage.</h4>
          </div>
        {/if}
        <ul class="divide-y divide-gray-200">
          {#each plans as plan}
            <PlanRow {plan} />
          {/each}
        </ul>

        <div class="mx-auto relative">
          <Dropdown open={openDropdown}>
            {#snippet button()}
              <span class="btn primary mr-2" data-name="new-plan-dropdown">
                New Plan
                <ChevronDown class="size-4" />
              </span>
            {/snippet}

            <div
              class="bg-white p-4 rounded-lg space-y-4 text-lwp-blue shadow-lg z-20"
            >
              <a href="/plans/new" class="hover:text-lwp-accent block">
                New Free Plan
              </a>
              <a
                href="/plans/new?selected_plan_id=standard"
                class="hover:text-lwp-accent block"
              >
                New Standard Plan
              </a>
            </div>
          </Dropdown>
        </div>
      </div>
    </section>

    {#if current_user.coach}
      <section class="max-w-3xl mx-auto lg:max-w-7xl">
        <div class="py-8 lg:py-12">
          <h2
            class="text-center text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
          >
            Your Coaching Plans
          </h2>
        </div>
      </section>

      <section class="max-w-3xl mx-auto lg:max-w-7xl px-3 lg:px-0">
        <div class="flex flex-col">
          {#if coaching_plans.length === 0}
            <p class="text-center">
              <span class="mt-3 block text-sm font-medium text-gray-800">
                You currently have no coaching plans.
              </span>
            </p>
          {/if}
          <ul class="divide-y divide-gray-200">
            {#each coaching_plans as plan}
              <PlanRow {plan} />
            {/each}
          </ul>
        </div>
      </section>
    {/if}
  </div>
</Layout>
